import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { RegionModel, RMHModel } from '../../models/DropDwon/RegionModel';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { DropDownRequest, DropDownResponse, RequirmentTypeModel, WHLocationModel } from '../../models/DropDwon/DropDownRequest';
import { productModel } from '../../models/DropDwon/ProductModel';
import { DynamicAddRow } from '../../models/DSDispatchToSD/AddRow';
import { Observable } from 'rxjs/Rx';
import { FormsModule } from '@angular/forms';
import { global } from '../../models/global';
import { ToastrService } from 'ngx-toastr';
import { DispatchToSDService } from '../../Services/DispatchToSD/dispatch-to-sd.service';
import { DatePipe } from '@angular/common';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';

@Component({
    selector: 'dispatch-sd',
    templateUrl: './dispatch-sd.component.html'
})
export class DispatchSDComponent implements OnInit {

    
    public loader: string = "none";
    @ViewChild('rmhSelect') rmhSelect;
    @ViewChild('productSelect') productSelect;
    @ViewChild('regionSelect') regionSelect;
    @ViewChild('sbu') sbu;
    @ViewChild('division') division;
    @ViewChild('zone') zone;
    @ViewChild('requirmentType') requirmentType;
    @ViewChild('WHLocationItem') WHLocationItem;
    @ViewChild('file') file;

    @ViewChild('AddRowWHLocation') AddRowWHLocation;
    @ViewChild('AddRowProduct') AddRowProduct;
    @ViewChild('AddRowPackSize') AddRowPackSize;
    @ViewChild('AddRowRecThrough') AddRowRecThrough;

    public form: FormGroup;

    public RmhSettings = {};
    public RmhSelectedItems: RMHModel[];

    public dropdownMonthSettings: {};

    public RegionSettings = {};
    public RegionselectedItems: RegionModel[];

    public SBUSettings = {};
    public SBUSelectedItem: SBUModel[];

    public DivisionSettings = {};
    public DivisionSelectedItem: DivisionModel[];

    public ZoneSettings = {};
    public ZoneSelectedItem: ZoneModel[];

    public userId: string;
    public roleId: string;
    public FlagDropDown: string;

    public ddlRequest: DropDownRequest = new DropDownRequest();
    public ddlResponse: DropDownResponse = new DropDownResponse();

    public ddlResponseWH: DropDownResponse = new DropDownResponse();

    public RequirmentTypeSettings = {};
    public requirmentTypeDdl: RequirmentTypeModel[];
    public requirmentDllValue: any;

    public WHLocationSettings = {};
    public whLocationDdl: WHLocationModel[];
    public whLocationDDlValue: any;

    public ProductSettings = {};
    public ProductSelectedItem: productModel[];


    public AddRowWHLocationSettings = {};
    public AddRowWHLocationDDlValue: any;

    public AddRowProductSettings = {};
    public AddRowProductSelectedItem: productModel[];

    public AddRowReceivedThroughSettings = {};
    public AddRowPackSizeSettings = {};



    approvefinalReqDetails: any[] = [];
    reqType: string;
    regionCode: string;
    wareHouseLocation: string;
    selectedReqType: any = [];
    selectedRegion: any = [];
    public files: File[] = [];
    public fileName: string = '';
    defaultView: boolean = true;
    totalRecord: any;
    currentPage: any;
    lastPage: any;
    isDisabledPrevious = true;
    isDisabledNext = false;
    dispatchToSDObj: any = [];
    userName: string;
    recordsOnCurrentPage: number = 10;
    startRecord: number = 1;
    defaultValue = "none";
    //dynamicAddRow: Array<DynamicAddRow> = [];  
    dynamicAddRow: any = [];
    newAddRow: any = {};
    productPackSize: any[] = [];
    displayReject = 'none';
    displayEdit = 'none';
    editStockIn: any = {};
    editProductPackSize: any[] = [];
    currentYear = new Date().getFullYear();
    constructor(private ddlServices: DropDownService, private toastr: ToastrService, private dispatchToSD: DispatchToSDService) {
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId');
        this.userName = localStorage.getItem('dsu_userName');
        this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44") ? "Supervisor" : "DEFAULT";
    }

    ngOnInit() {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse = response.data;
                }   
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });


        this.SBUMHSetting();
        this.DivisionSetting();
        this.ZoneSetting();
        this.RmhSetting();
        this.RegionSetting();
        this.requirmentTypeDdl = [{ id: 1, text: "Annual" }, { id: 2, text: "Additional" }];
        this.RequirmentTypeSetting();
        // this.WHLocation();
        this.WHLocationSetting();
        this.GetWarehouseLocationData(this.userId, this.roleId, "TRUE");
        this.ProductSetting();
        this.reqType = '';
        this.regionCode = '';
        this.AddRowWHLocationSetting();
        this.AddRowProductSetting();
        this.AddRowPackSizeSetting();
        this.AddRowReceivedThrough();
        this.loader = 'none';
    }

    RmhSetting() {
        this.RmhSettings = {
            singleSelection: false,
            idField: 'rmhCode',
            textField: 'rmhName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No RMH Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }

    RegionSetting() {
        this.RegionSettings = {
            singleSelection: false,
            idField: 'regionCode',
            textField: 'regionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Region Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    SBUMHSetting() {
        this.SBUSettings = {
            singleSelection: false,
            idField: 'sbuCode',
            textField: 'sbuName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No SBU Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    DivisionSetting() {
        this.DivisionSettings = {
            singleSelection: false,
            idField: 'divisionCode',
            textField: 'divisionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Division Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ZoneSetting() {
        this.ZoneSettings = {
            singleSelection: false,
            idField: 'zoneCode',
            textField: 'zoneName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Zone Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    
    RequirmentTypeSetting() {
        this.RequirmentTypeSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'text',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Requirment Type Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    WHLocationSetting() {
        this.WHLocationSettings = {
            singleSelection: false,
            idField: 'whId',
            textField: 'whName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    WHLocation() {
        this.whLocationDdl = [{ WHId: "1", WHName: "WHName1" }, { WHId: "2", WHName: "WHName2" }]
    }

    AddRowWHLocationSetting() {
        this.AddRowWHLocationSettings = {
            singleSelection: true,
            idField: 'whCode',
            textField: 'whName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Location Found',
            closeDropDownOnSelection: true,
        };
    }

    AddRowReceivedThrough() {
        this.AddRowReceivedThroughSettings = {
            singleSelection: true,
            idField: 'receivedThrough',
            textField: 'receivedThrough',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Received Through Found',
            closeDropDownOnSelection: true,
        };
    }

    AddRowPackSizeSetting() {
        this.AddRowPackSizeSettings = {
            singleSelection: true,
            idField: 'packSize',
            textField: 'packSize',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Pack Size Found',
            closeDropDownOnSelection: true,

        };
    }


    AddRowProductSetting() {
        this.AddRowProductSettings = {
            singleSelection: true,
            idField: 'productCode',
            textField: 'productName',
            allowSearchFilter: true,
            clearSearchFilter: true,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: true,

        };
    }
    ConvertToCurrency(value:any)
    {
        var parts = value.toString().replace(',','').split(".");
        if(parts[0].length > 3){
        parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
        }
        return parts.join(".");
    }

    public onSBUSelect(item: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelect(item: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onSBUSelectAll(items: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelectAll(items: any) {
        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onDivisionSelect(item: any) {
        this.GetDivisionWiseData(this.division.selectedItems);

    }
    public onDivisionDeSelect(item: any) {
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onDivisionSelectAll(items: any) {
        this.GetDivisionWiseData(this.division.selectedItems);
    }
    public onDivisionDeSelectAll(items: any) {
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onZoneSelect(item: any) {

        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelect(item: any) {
        this.GetZoneWiseData(this.zone.selectedItems);
    }

    public onZoneSelectAll(items: any) {
        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelectAll(items: any) {
        this.GetZoneWiseData(this.zone.selectedItems);
    }

    GetSBUWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.division = response.data.division;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    }
    GetDivisionWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.rmh = response.data.rmh;
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    }
    GetZoneWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    }

    onReqTypeSelect(item: any) {
        if (item.length == 1) {
            this.selectedReqType = item.text
        } else {
            this.selectedReqType = item.text
        }
        this.RequirmentTypeSetting();
    }
    onReqTypeAll(items: any) {
    }

    onRegionSelect(item: any) {
        if (item.length == 1) {
            this.selectedRegion = item.regionCode
        } else {
            this.selectedRegion = item.regionCode
        }
        this.RequirmentTypeSetting();
    }
    onRegionAll(items: any) {
    }


    ProductSetting() {
        this.ProductSettings = {
            singleSelection: false,
            idField: 'productId',
            textField: 'productName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }



    GetWarehouseLocationData(userId: string, roleId: string, IsOnInit: string) {
        let obj: DropDownRequest = new DropDownRequest();

        this.loader = 'block';
        obj.UserId = this.userId;
        obj.Role = this.roleId;
        obj.Flag = IsOnInit;
        obj.SD = '';
        this.ddlServices.getWarehouseLocationDropDown(obj)
            .subscribe((response) => {
                if (response.status) {

                    this.ddlResponseWH.warehouseLocation = response.data.warehouse;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }

    DownloadExcel() {

        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");

        if (whLocation == "" || whLocation == null) {
            this.toastr.error("Please select Warehouse Location");
            return false;
        }
        if (product == "" || product == null) {
            this.toastr.error("Please select Product");
            return false;
        }


        let today = new Date();
        let month;
        if((today.getMonth() + 1)<10)
        {
            month = '0' + (today.getMonth() + 1).toString().slice(-2);
        }
        else
        {
            month =  (today.getMonth() + 1).toString().slice(-2);
        }
        let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
        this.loader = 'block';
        this.userId = localStorage.getItem('dsu_userId');



        this.dispatchToSD.DownloadExcel(this.userId, whLocation, product)
            .subscribe(success => {
                if (success.ok = true) {
                    var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
                    saveAs(blob, this.userName + "_DispatchToSD_" + formattedDate + ".xlsx");
                }
                this.loader = 'none';
            },
                err => {

                    this.toastr.error("No data found");
                    //alert("Some problem occurred while downloading file.");
                    this.loader = 'none';
                });
    }

    filesDroppedAdd(files: File[]) {
        this.files = [];
        this.files = files;
        let fileNameParts: string[] = files[0].name.split('.');
        let fileType = files[0].name.split('.')[fileNameParts.length - 1];
        let UserId = localStorage.getItem('dsu_userId');

        if (fileType != 'xls' && fileType != 'xlsx') {
            // this.snackBar.openSnackBar('Please Select Valid File Type.','Close','red-snackbar');
            this.toastr.error("Please Select Valid File Type.");
            return false;
        }

        this.loader = 'block';
        var uploadedFile = <File>this.files[0];
        this.dispatchToSD.UploadDocument(uploadedFile, UserId)
            .subscribe((resData: any) => {
                if (resData.status) {
                    this.toastr.success(resData.message);
                    this.GetDispatchToSD();
                }
                else {
                    this.toastr.error(resData.message);
                }

                this.loader = 'none';
                this.file.nativeElement.value = '';
            }, error => {

                this.loader = 'none';
                this.file.nativeElement.value = '';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });

    }

    //   GetDispatchToSD(currentPage : any) {

    //     this.isDisabledPrevious = true;
    //     this.isDisabledNext=false;
    //     this.userId = localStorage.getItem('dsu_userId');
    //     let product=Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
    //     let whLocation=Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
    //     let page = currentPage;
    //     this.startRecord=1;

    //     if(whLocation=="" || whLocation==null){
    //         this.toastr.error("Please select WH Location");
    //         return false;
    //     }
    //     else{
    //         this.loader = 'block';
    //         this.dispatchToSD.GetDispatchToSD(whLocation, product, this.userId,page)
    //         .subscribe((response) => {
    //             if (response.status) {
    //                 //window.location.href = response.filePath;
    //                 this.defaultView=false;
    //                 this.dispatchToSDObj = response.data;
    //                 this.totalRecord = this.dispatchToSDObj.pagination.totalRecord;
    //                 this.currentPage=this.dispatchToSDObj.pagination.currentPage;
    //                 this.lastPage=this.dispatchToSDObj.pagination.lastPage;
    //                 this.recordsOnCurrentPage = this.currentPage * 10;

    //                 if (this.currentPage > 1) {
    //                   this.isDisabledPrevious = false;
    //                   this.startRecord = (this.currentPage - 1) * 10 + 1;
    //               }
    //                if(this.currentPage==this.lastPage)
    //               {
    //                   this.isDisabledNext=!this.isDisabledNext;
    //                   this.recordsOnCurrentPage=this.totalRecord;
    //               }
    //               if(this.dispatchToSDObj.dispatchToSDList.length==0){
    //                 this.startRecord=0;
    //                 this.recordsOnCurrentPage=0;
    //             }

    //             }
    //             else {
    //                 this.toastr.error(response.message);
    //             }
    //             this.loader = 'none';
    //         }, error => {
    //             this.loader = 'none';
    //         });
    //     }

    // }
    reset() {
        this.defaultValue = 'none';
        if (this.requirmentType != undefined) {
            this.requirmentType.selectedItems = [];
        }
        if (this.rmhSelect != undefined) {
            this.rmhSelect.selectedItems = [];
        }
        if (this.productSelect != undefined) {
            this.productSelect.selectedItems = [];
        }
        //   if (this.cropSelect != undefined) {
        //     this.cropSelect.selectedItems = [];
        //   }
        if (this.sbu != undefined) {
            this.sbu.selectedItems = [];
        }
        if (this.division != undefined) {
            this.division.selectedItems = [];
        }
        if (this.zone != undefined) {
            this.zone.selectedItems = [];
        }
        if (this.regionSelect != undefined) {
            this.regionSelect.selectedItems = [];
        }
        if (this.WHLocationItem != undefined) {
            this.WHLocationItem.selectedItems = [];
        }

        this.defaultView = true;
    }

    DownloadExcelForAdmin() {
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");

        if (whLocation == "" || whLocation == null) {
            this.toastr.error("Please select Warehouse Location");
            return false;
        }
        if (product == "" || product == null) {
            this.toastr.error("Please select Product");
            return false;
        }


        let today = new Date();
        let month;
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
        let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
        this.loader = 'block';
        this.userId = localStorage.getItem('dsu_userId');
        this.dispatchToSD.DownloadExcelForAdmin(this.userId, whLocation, product)
            .subscribe(success => {
                if (success.ok = true) {
                    var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
                    saveAs(blob, this.userName + "_DispatchToSD_" + formattedDate + ".xlsx");
                }
                this.loader = 'none';
            },
                err => {

                    this.toastr.error("No data found");
                    this.loader = 'none';

                });
    }

    GetDispatchToSD() {
        let isValid = true;
        this.userId = localStorage.getItem('dsu_userId');
        let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        let whLocation = Array.prototype.map.call(this.WHLocationItem.selectedItems, function (item) { return item.id; }).join(",");
        if (whLocation == "" || whLocation == null) {
            this.toastr.error("Please select Warehouse Location");
            isValid = false;
            return false;
        }
        if (product == "" || product == null) {
            this.toastr.error("Please select Product");
            isValid = false;
            return false;
        }

        if (isValid) {
            this.loader = 'block';
            this.dispatchToSD.GetDispatchToSD(whLocation, product, this.userId)
                .subscribe((response) => {
                    if (response.status) {
                        this.dynamicAddRow = [];
                        this.defaultView = false;
                        this.dispatchToSDObj = response.data;
                        //this.AddRowWHLocationSetting();
                        this.AddRowProductSetting();
                        this.AddRowReceivedThrough();
                        this.AddRowPackSizeSetting();


                        // for (let i = 0; i < response.data.editDispatchtoSD.length; i++) {
                        //     this.AddRowForEdit(i,response.data.editDispatchtoSD[i]);
                        // }
                        //this.AddRow(response.data.editDispatchtoSD.length);
                        this.AddRow(0);

                        console.log(response.data);
                    }
                    else {
                        this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                });
        }

    }

    AddRowForEdit(index, data) {
        var datePipe = new DatePipe("en-US");
        let stockDate = data.stockReceiptDate;
        data.stockReceiptDate = datePipe.transform(stockDate, 'dd/MMM/yyyy');
        let mfgDate = data.mfgDate;
        data.mfgDate = datePipe.transform(mfgDate, 'dd/MMM/yyyy');
        let expDate = data.expDate;
        data.expDate = datePipe.transform(expDate, 'dd/MMM/yyyy');
        let invDate = data.invDate;
        data.invDate = datePipe.transform(invDate, 'dd/MMM/yyyy');

        this.newAddRow =
        {
            Id: data.id,
            WarehouseCode: data.warehouseCode,
            WarehouseLocation: data.warehouseLocation,
            ItemCode: data.itemCode,
            ItemName: data.itemName,
            PackSize: data.packSize,
            StockReceiptDate: data.stockReceiptDate,
            ReceivedThrough: data.receivedThrough,
            ReceivedFrom: data.receivedFrom,
            BatchNo: data.batchNo,
            QtyMentionedInDoc: data.qtyMentionedInDoc,
            ActualQtyReceived: data.actualQtyReceived,
            NoofCase: data.noofCase,
            MFGDate: data.mfgDate,
            EXPDate: data.expDate,
            DocNo: data.docNo,
            InvNo: data.invNo,
            INVDate: data.invDate,
            IsEdit: false

        }

        let WHSelected = { whCode: data.warehouseCode, whName: data.warehouseLocation };
        this.newAddRow.WHSelectedList = [];
        this.newAddRow.WHSelectedList.push(WHSelected);


        let ProductSelected = { productCode: data.itemCode, productName: data.itemName };
        this.newAddRow.ProductSelectedList = [];
        this.newAddRow.ProductSelectedList.push(ProductSelected);

        let PackSizeSelected = { packSize: data.packSize };
        this.newAddRow.PackSizeSelectedList = [];
        this.newAddRow.PackSizeSelectedList.push(PackSizeSelected);

        let RecThroughSelected = { receivedThrough: data.receivedThrough };
        this.newAddRow.RecThroughSelectedList = [];
        this.newAddRow.RecThroughSelectedList.push(RecThroughSelected);

        this.productPackSize.push(0);
        this.productPackSize[index] = [];
        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == data.itemCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.productPackSize[index].push(packSize);


            }
        }
        this.dynamicAddRow.push(this.newAddRow);

    }


    AddRow(index) {
        this.newAddRow =
        {
            Id: 0,
            WarehouseCode: "",
            WarehouseLocation: "",
            ItemCode: "",
            ItemName: "",
            PackSize: "",
            StockReceiptDate: "",
            ReceivedThrough: "",
            ReceivedFrom: "",
            BatchNo: "",
            QtyMentionedInDoc: "",
            ActualQtyReceived: "",
            NoofCase: "",
            MFGDate: "",
            EXPDate: "",
            DocNo: "",
            InvNo: "",
            INVDate: "",
            IsEdit: true
        }
        this.productPackSize.push(0);
        this.dynamicAddRow.push(this.newAddRow);
        return true;
    }

    DeleteRow(index) {
        if (this.dynamicAddRow.length == 1) {
            this.toastr.error("Can't delete the row when there is only one row");
            return false;
        }
        else {
            this.dynamicAddRow.splice(index, 1);
            return true;
        }
    }

    IsAlphaNumeric(event: any) {
        var newKeyCode = event.keyCode;
        return ((newKeyCode > 64 && newKeyCode < 91) || (newKeyCode > 96 && newKeyCode < 123) || (newKeyCode == 8 || newKeyCode == 32) || (newKeyCode >= 48 && newKeyCode <= 57) || newKeyCode == 59);
    }

    onAddRowProductSelect(item: any, index: any) {
        this.productPackSize[index] = [];

        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == item.productCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.productPackSize[index].push(packSize);


            }
        }

        this.dynamicAddRow[index].PackSizeSelectedList = [];

        this.dynamicAddRow[index].ItemCode = item.productCode;
        this.dynamicAddRow[index].ItemName = item.productName;


    }
    onAddRowProductDeSelect(item: any, index: any) {
        this.productPackSize[index] = [];
    }

    onAddRowReceivedThrough(item: any, index: any) {
        this.dynamicAddRow[index].ReceivedThrough = item.receivedThrough;
    }
    onAddRowReceivedThroughDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].ReceivedThrough = "";
    }
    onAddRowPackSize(item: any, index: any) {
        this.dynamicAddRow[index].PackSize = item.packSize;
    }
    onAddRowPackSizeDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].PackSize = "";
    }
    onAddRowWHLocation(item: any, index: any) {
        this.dynamicAddRow[index].WarehouseCode = item.whCode;
        this.dynamicAddRow[index].WarehouseLocation = item.whName;
    }

    ononAddRowWHLocationDeSelect(item: any, index: any) {
        this.dynamicAddRow[index].WarehouseCode = "";
        this.dynamicAddRow[index].WarehouseLocation = "";
    }
    onDateSelectEXPDate(newValueEXPDate, index) {
        this.dynamicAddRow[index].MFGDate
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].EXPDate = nwValue;
    }
    onDateSelectMFGDate(newValueEXPDate, index) {
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].MFGDate = nwValue;
    }
    onDateSelectStockDate(newValueEXPDate, index) {
        let nwValue = newValueEXPDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].StockReceiptDate = nwValue;
    }
    onDateSelectINVDate(newValueINVDate, index) {
        let nwValue = newValueINVDate;
        var datePipe = new DatePipe("en-US");
        nwValue = datePipe.transform(nwValue, 'dd/MMM/yyyy')
        this.dynamicAddRow[index].INVDate = nwValue;
    }

    ValidateDispatchtoSD(dynamicAddRow: any) {
        this.displayReject = 'none';
        let isValid = true;
        for (let i = 0; i < dynamicAddRow.length; i++) {
            if (!Boolean(dynamicAddRow[i].WarehouseCode)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].WarehouseLocation)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].ItemCode)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].ItemName)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].PackSize)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].StockReceiptDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].ReceivedThrough)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].ReceivedFrom)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].BatchNo)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].QtyMentionedInDoc)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].ActualQtyReceived)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].NoofCase)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].MFGDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].DocNo)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].EXPDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].InvNo)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            if (!Boolean(dynamicAddRow[i].INVDate)) {
                isValid = false;
                this.toastr.error("Please fill all required fields.");
                return false;
            }
            let mfgDate = new Date(dynamicAddRow[i].MFGDate);
            let expDate = new Date(dynamicAddRow[i].EXPDate);
            if (expDate <= mfgDate) {
                isValid = false;
                this.toastr.error("EXP Date must be greater than MFG Date.");
                return false;
            }
        }
        if (isValid) {

            this.displayReject = 'block';
        }


        //console.log(dynamicAddRow);
    }
    closePopup(commentModal: string) {
        this.displayReject = 'none';
        this.displayEdit = 'none';
    }

    SaveDispatchtoSD(dynamicAddRow: any) {
        this.loader = 'block';
        this.displayReject = 'none';
        this.userId = localStorage.getItem('dsu_userId');
        this.dispatchToSD.SaveDispatchToSD(dynamicAddRow, this.userId)
            .subscribe((response) => {
                if (response.status) {
                    this.defaultView = true;
                    this.toastr.success(response.message);
                }
                else {
                    this.toastr.error(response.message);
                }
                this.loader = 'none';
            }, error => {
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });
    }

    EditRow(stock: any) {
        //this.editStockIn = stock;
        this.editStockIn = this.DeepCopy(stock);
        this.editStockIn.productId = this.editStockIn.productCode;
        this.editStockIn.whLocation = this.editStockIn.whName;
        this.displayEdit = "block";
        let WHSelected = { whCode: this.editStockIn.whCode, whName: this.editStockIn.whName };
        this.editStockIn.WHSelectedList = [];
        this.editStockIn.WHSelectedList.push(WHSelected);


        let ProductSelected = { productCode: this.editStockIn.productCode, productName: this.editStockIn.productName };
        this.editStockIn.ProductSelectedList = [];
        this.editStockIn.ProductSelectedList.push(ProductSelected);

        let PackSizeSelected = { packSize: this.editStockIn.packSize };
        this.editStockIn.PackSizeSelectedList = [];
        this.editStockIn.PackSizeSelectedList.push(PackSizeSelected);

        let RecThroughSelected = { receivedThrough: this.editStockIn.receivedThrough };
        this.editStockIn.RecThroughSelectedList = [];
        this.editStockIn.RecThroughSelectedList.push(RecThroughSelected);

    }

    onEditRowProductSelect(item: any, index: any) {
        this.editProductPackSize = [];

        for (let i = 0; i < this.dispatchToSDObj.dsAddStock.packSize.length; i++) {
            if (this.dispatchToSDObj.dsAddStock.packSize[i].productCode == item.productCode) {
                let packSize: any = {};
                packSize.packSize = this.dispatchToSDObj.dsAddStock.packSize[i].packSize;
                this.editProductPackSize.push(packSize);


            }
        }

        this.editStockIn.PackSizeSelectedList = [];

        this.editStockIn.productId = item.productCode;
        this.editStockIn.productName = item.productName;


    }

    onEditRowProductDeSelect(item: any, index: any) {
        this.editStockIn.productName = "";
        this.editStockIn.productId = "";
    }

    onEditRowReceivedThrough(item: any, index: any) {
        this.editStockIn.receivedThrough = item.receivedThrough;
    }
    onEditRowReceivedThroughDeSelect(item: any, index: any) {
        this.editStockIn.receivedThrough = "";
    }
    onEditRowPackSize(item: any, index: any) {
        this.editStockIn.packSize = item.packSize;
    }
    onEditRowPackSizeDeSelect(item: any, index: any) {
        this.editStockIn.packSize = "";
    }
    onEditRowWHLocation(item: any, index: any) {
        this.editStockIn.whCode = item.whCode;
        this.editStockIn.whLocation = item.whName;
    }

    onEditRowWHLocationDeSelect(item: any, index: any) {
        this.editStockIn.whCode = "";
        this.editStockIn.whName = "";
    }

    DeepCopy(obj: any): any {
        let clonedObject;

        if (obj === null || typeof obj !== 'object') {
            return obj;
        }
        if (obj instanceof Array) {
            clonedObject = [];
            for (let i = 0; i < obj.length; i++) {
                clonedObject[i] = this.DeepCopy(obj[i]);
            }
            return clonedObject;
        }
        if (obj instanceof Date) {
            clonedObject = new Date(obj.valueOf());
            return clonedObject;
        }
        if (obj instanceof RegExp) {
            clonedObject = RegExp(obj.source, obj.flags);
            return clonedObject;
        }
        if (obj instanceof Object) {
            clonedObject = new obj.constructor();
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) {
                    clonedObject[attr] = this.DeepCopy(obj[attr]);
                }
            }
            return clonedObject;
        }
    }

    EditDispatchtoSD(stockIn) {
        let isValid = true;
        if (!Boolean(stockIn.whCode)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.whLocation)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.productId)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.productName)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.packSize)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.stockReceiptDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.receivedThrough)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.receivedFrom)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.batchNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.qtyMentioned)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.qtyReceived)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.noofCase)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.mfgDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.docNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.expDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.invNo)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        if (!Boolean(stockIn.invDate)) {
            isValid = false;
            this.toastr.error("Please fill all required fields.");
            return false;
        }
        let mfgDate = new Date(stockIn.mfgDate);
        let expDate = new Date(stockIn.expDate);
        if (expDate <= mfgDate) {
            isValid = false;
            this.toastr.error("EXP Date must be greater than MFG Date.");
            return false;
        }

        this.displayEdit = 'none';
        this.loader = 'block';

        if (isValid) {
            stockIn.userId = localStorage.getItem('dsu_userId');
            console.log(stockIn);
            this.dispatchToSD.UpdateStockIn(stockIn)
                .subscribe((response) => {

                    if (response.status) {
                        this.defaultView = true;
                        this.toastr.success(response.message);
                        this.GetDispatchToSD();
                    }
                    else {
                        this.toastr.error(response.message);
                    }
                    this.loader = 'none';
                }, error => {
                    this.loader = 'none';
                    this.toastr.error('Some Problem Occured,Please try again later.');
                });

        }
    }
}